var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBusinessCentral = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 36,
    height: 36,
    x: 2,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38 2H2v36h36z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 36,
    height: 36,
    x: 2,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8DF7DB",
    fillRule: "evenodd",
    d: "M2 20a3.376 3.376 0 0 0 2.593 3.284 15.77 15.77 0 0 0 12.123 12.123 3.376 3.376 0 0 0 6.568 0 15.77 15.77 0 0 0 12.123-12.123 3.376 3.376 0 0 0 0-6.568A15.77 15.77 0 0 0 23.284 4.593a3.376 3.376 0 0 0-6.568 0A15.77 15.77 0 0 0 4.593 16.716 3.376 3.376 0 0 0 2 20",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M20 38c9.941 0 18-8.059 18-18S29.941 2 20 2 2 10.059 2 20s8.059 18 18 18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9DF3F9",
    fillRule: "evenodd",
    d: "M21.5 8.4a3.375 3.375 0 1 0-3 0v2.225h3V8.399Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82EBF1",
    fillRule: "evenodd",
    d: "M18.5 31.6a3.375 3.375 0 1 0 3 0v-2.225h-3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9DF3F9",
    fillRule: "evenodd",
    d: "M8.4 18.5a3.375 3.375 0 1 0 0 3h2.225v-3H8.399Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.32,
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 30.5c5.385 0 9.75-4.365 9.75-9.75S25.385 11 20 11s-9.75 4.365-9.75 9.75S14.615 30.5 20 30.5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24.244 22.25a4.502 4.502 0 0 1-8.744-1.5 4.5 4.5 0 0 1 8.744-1.5H32v3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.625 24.125a3.375 3.375 0 1 1 0-6.75 3.375 3.375 0 0 1 0 6.75"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.24,
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 29.893c5.385 0 9.75-4.366 9.75-9.75s-4.365-9.75-9.75-9.75-9.75 4.365-9.75 9.75 4.365 9.75 9.75 9.75"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24.244 21.642a4.502 4.502 0 0 1-8.744-1.5 4.5 4.5 0 0 1 8.744-1.5H32v3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.625 23.517a3.375 3.375 0 1 1 0-6.75 3.375 3.375 0 0 1 0 6.75"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M20 29.75c5.385 0 9.75-4.365 9.75-9.75s-4.365-9.75-9.75-9.75-9.75 4.365-9.75 9.75 4.365 9.75 9.75 9.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    fillRule: "evenodd",
    d: "M24.244 21.5A4.502 4.502 0 0 1 15.5 20a4.5 4.5 0 0 1 8.744-1.5H32v3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M34.625 23.375a3.375 3.375 0 1 1 0-6.75 3.375 3.375 0 0 1 0 6.75"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 10.514,
    x2: 29.243,
    y1: 6.257,
    y2: 33.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009CA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007D85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 13.919,
    x2: 26.811,
    y1: 11.851,
    y2: 33.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36E3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 13.676,
    x2: 30.216,
    y1: 11,
    y2: 25.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82EBF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 38.365,
    x2: 29.122,
    y1: 21.095,
    y2: 17.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AEEF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82EBF1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 43.75,
    height: 35.5,
    x: 2.25,
    y: 3,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_758_609",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: 29.27,
    height: 21.02,
    x: 9.49,
    y: 9.633,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_758_609",
    stdDeviation: 0.38
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBusinessCentral);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/business-central.f190e9d3.svg";